import { render, staticRenderFns } from "./GetAllLanguages.vue?vue&type=template&id=cec03f52&"
import script from "./GetAllLanguages.vue?vue&type=script&lang=js&"
export * from "./GetAllLanguages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports